import React, { useState } from 'react';
import PropTypes from "prop-types";
import { useRouteMatch } from 'react-router';
import { EuiImage } from '../../../../src/components/image';
import { EuiButton } from '../../../../src/components/button';
import { EuiSpacer } from '../../../../src/components/spacer';
import { EuiSwitch } from '../../../../src/components/form';
import { EuiTextAlign } from '../../../../src/components/text';
import { useIsWithinBreakpoints } from '../../../../src/services/hooks';
import { useExitPath } from '../../services/routing/routing';
import contentSvg from '../../images/content.svg';
import contentCenterSvg from '../../images/content_center.svg';
import sideNavSvg from '../../images/side_nav.svg';
import singleSvg from '../../images/single.svg';

var ExitFullscreenDemoButton = function ExitFullscreenDemoButton() {
  var exitPath = useExitPath();
  return ___EmotionJSX(EuiButton, {
    fill: true,
    href: exitPath,
    iconType: "exit"
  }, "Exit fullscreen");
};
/**
 * Because the discrete[by slug] usages of <PageDemo> are not rendered at the same time,
 * it is safe to cache their showTemplate status in a set rather than an approach triggering
 * React re-rendering. If that changes, moving this to a redux store, recoiljs atom(s), or similar
 * would resolve any introduced issue.
 */


var demosAsIndividualComponents = new Set();
export var PageDemo = ({
  slug,
  fullscreen,
  pattern,
  template,
  centered
}) => {
  const {
    path
  } = useRouteMatch();
  const isMobileSize = useIsWithinBreakpoints(['xs', 's']);
  const [showTemplate, _setShowTemplate] = useState(!demosAsIndividualComponents.has(slug));

  const setShowTemplate = cb => {
    _setShowTemplate(showing => {
      const nextValue = cb(showing);
      demosAsIndividualComponents[nextValue ? 'delete' : 'add'](slug);
      return nextValue;
    });
  };

  const button = fullscreen ? <ExitFullscreenDemoButton /> : <EuiButton fill href={`#${path}/${slug}`}>
      Go fullscreen
    </EuiButton>;
  const sideNav = <EuiImage size={isMobileSize ? 'original' : 'fullWidth'} alt="Fake side nav list" url={isMobileSize ? singleSvg : sideNavSvg} />;
  const content = <>
      <EuiImage size="fullWidth" alt="Fake paragraph" url={centered ? contentCenterSvg : contentSvg} />
      {!centered && <>
          <EuiSpacer />
          <EuiImage size="fullWidth" alt="Fake paragraph" url={centered ? contentCenterSvg : contentSvg} />
        </>}
    </>;
  const bottomBar = <EuiButton size="s" color="ghost">
      Save
    </EuiButton>;
  const Child = showTemplate ? template : pattern;
  return fullscreen ? <Child button={button} content={content} sideNav={sideNav} bottomBar={bottomBar} /> : <>
      <div className={'guideDemo__highlightLayout'}>
        <Child button={button} content={content} sideNav={sideNav} bottomBar={bottomBar} />
      </div>
      <EuiTextAlign textAlign="right">
        <EuiSpacer />
        <EuiSwitch label="Show with individual components" checked={!showTemplate} onChange={() => setShowTemplate(showing => !showing)} />
      </EuiTextAlign>
    </>;
};
PageDemo.propTypes = {
  slug: PropTypes.string.isRequired,
  fullscreen: PropTypes.bool,
  pattern: PropTypes.elementType.isRequired,
  template: PropTypes.elementType.isRequired,
  centered: PropTypes.bool
};

try {
  PageDemo.__docgenInfo = {
    tags: {},
    filePath: '/app/src-docs/src/views/page/_page_demo.tsx',
    description: '',
    displayName: 'PageDemo',
    methods: [],
    props: {
      slug: {
        defaultValue: null,
        description: '',
        name: 'slug',
        parent: undefined,
        declarations: [{
          fileName: 'app/src-docs/src/views/page/_page_demo.tsx',
          name: 'TypeLiteral'
        }],
        required: true,
        type: {
          name: 'string'
        }
      },
      fullscreen: {
        defaultValue: null,
        description: '',
        name: 'fullscreen',
        parent: undefined,
        declarations: [{
          fileName: 'app/src-docs/src/views/page/_page_demo.tsx',
          name: 'TypeLiteral'
        }],
        required: false,
        type: {
          name: 'boolean'
        }
      },
      pattern: {
        defaultValue: null,
        description: '',
        name: 'pattern',
        parent: undefined,
        declarations: [{
          fileName: 'app/src-docs/src/views/page/_page_demo.tsx',
          name: 'TypeLiteral'
        }],
        required: true,
        type: {
          name: 'ComponentType<{ button: ReactElement; content: ReactElement<any, string | JSXElementConstructor<any>>; sideNav: ReactElement<...>; bottomBar: ReactElement<...>; }>'
        }
      },
      template: {
        defaultValue: null,
        description: '',
        name: 'template',
        parent: undefined,
        declarations: [{
          fileName: 'app/src-docs/src/views/page/_page_demo.tsx',
          name: 'TypeLiteral'
        }],
        required: true,
        type: {
          name: 'ComponentType<{ button: ReactElement; content: ReactElement<any, string | JSXElementConstructor<any>>; sideNav: ReactElement<...>; bottomBar: ReactElement<...>; }>'
        }
      },
      centered: {
        defaultValue: null,
        description: '',
        name: 'centered',
        parent: undefined,
        declarations: [{
          fileName: 'app/src-docs/src/views/page/_page_demo.tsx',
          name: 'TypeLiteral'
        }],
        required: false,
        type: {
          name: 'boolean'
        }
      }
    },
    extendedInterfaces: []
  };
} catch (e) {}